import API from '/b2b/common/helpers/API';
import { API_NAME } from '#config/runtimeconfig';
import { allSettled } from '../common/services/helpers';
import { formatDashboardTodos } from './format';
import { handleError } from '../common/services/helpers';

export const fetchProductTodos = product =>
    API.get(API_NAME, `/${product}/to-do`).catch(handleError);

export const fetchDashboardTodos = ({
    canViewAssessments = false,
    canViewCookieConsent = false,
    canViewDataMapping = false,
    canViewSubjectRights = false,
    canViewUnifiedConsent = false,
    canViewVendorMonitoring = false,
}) =>
    allSettled([
        canViewAssessments && fetchProductTodos('assessment-management'),
        canViewCookieConsent && fetchProductTodos('consentmanager'),
        canViewDataMapping && fetchProductTodos('data-mapping'),
        canViewSubjectRights && fetchProductTodos('dsar'),
        canViewUnifiedConsent && fetchProductTodos('uc'),
        canViewVendorMonitoring && fetchProductTodos('vendor-management'),
    ])
        .then(
            ([
                assessments,
                cookieConsent,
                dataMapping,
                subjectRights,
                unifiedConsent,
                vendorMonitoring,
            ]) => ({
                assessments: assessments?.value || {},
                cookieConsent: cookieConsent?.value || {},
                dataMapping: dataMapping?.value || {},
                subjectRights: subjectRights?.value || {},
                unifiedConsent: unifiedConsent?.value || {},
                vendorMonitoring: vendorMonitoring?.value || {},
            })
        )
        .then(formatDashboardTodos);
